/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { TextInput, type TextInputProps } from 'react-native';

import {
  bindNumericOnChange,
  numericTextInputDefaults,
  type NumericInputKind,
} from '../../shared/numeric/public-api';

export type NumericTextInputProps = Omit<TextInputProps, 'keyboardType' | 'inputMode' | 'onChangeText'> & {
  kind: NumericInputKind;
  value: string;
  onChangeText: (text: string) => void;
  /**
   * Texto crudo ANTES del sanitize de `kind`. Sirve para detectar caracteres
   * que el sanitizador descarta (ej. separador decimal en campos enteros).
   */
  onRawChangeText?: (text: string) => void;
};

export const NumericTextInput = React.forwardRef<TextInput, NumericTextInputProps>(function NumericTextInput(
  { kind, value, onChangeText, onRawChangeText, ...rest },
  ref
) {
  const defaults = numericTextInputDefaults(kind);
  const bound = bindNumericOnChange(onChangeText, kind);
  return (
    <TextInput
      ref={ref}
      {...defaults}
      {...rest}
      value={value}
      onChangeText={(text) => {
        onRawChangeText?.(text);
        bound(text);
      }}
    />
  );
});
